import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchEdiRfidAuditDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteEdiRfidAudit',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.delete(serviceUrl, {
    data: {
      requestIds: payload.params.requestIds,
    },
  });
};

export default apiFetchEdiRfidAuditDelete;
